import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { CatalogForm } from '../../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../../components/CatalogForm/validators';
import { ClienteService } from '../../../../services/ClienteService';
import Http from '../../../../Http';

export const ClientePagos = ({ match, id: propId, onSave }) => {
  const routeParams = useParams() || {};
  const clientId = propId || match?.params?.id || routeParams?.id;

  const [bancos, setBancos] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchBancos = async () => {
      try {
        const opts = await ClienteService.obtenerCatalogoOptions();
        if (mounted && opts?.bancos && opts.bancos.length) {
          setBancos(
            opts.bancos.map((b) => ({
              value: String(b.id),
              label: b.banco_nombre || b.banco || `Banco ${b.id}`,
            }))
          );
        } else {
          // Fallback directo a banco/all
          const res = await Http.get('banco/all');
          if (mounted && res && !res.error && Array.isArray(res.data)) {
            setBancos(
              res.data.map((b) => ({
                value: String(b.id),
                label: b.banco_nombre || b.banco || `Banco ${b.id}`,
              }))
            );
          }
        }
      } catch (err) {
        console.error('Error cargando catálogo de bancos', err);
      }
    };
    fetchBancos();
    return () => {
      mounted = false;
    };
  }, []);

  const loadClientData = useCallback(async () => {
    if (!clientId) return null;
    try {
      const data = await ClienteService.obtenerDetalleCompleto(clientId);
      if (!data) return null;

      return {
        cliente_id_banco: data.cliente_id_banco ? String(data.cliente_id_banco) : '',
        cliente_numero_cuenta: data.cliente_numero_cuenta || '',
        cliente_clabe: data.cliente_clabe || '',
      };
    } catch (e) {
      console.error('Error al cargar datos bancarios', e);
      return null;
    }
  }, [clientId]);

  const fields = useMemo(
    () => [
      {
        name: 'section_bancarios',
        label: 'Información de Cuentas y Transferencias',
        type: 'section',
        col: 12,
      },
      {
        name: 'cliente_id_banco',
        label: 'Institución Bancaria',
        type: 'select',
        col: 6,
        required: true,
        validators: [Validators.required('El banco es requerido')],
        options: bancos,
        placeholder: 'Seleccione un banco',
      },
      {
        name: 'cliente_numero_cuenta',
        label: 'Número de Cuenta',
        type: 'text',
        col: 6,
        required: true,
        validators: [Validators.required('El número de cuenta es requerido')],
        placeholder: 'Número de cuenta o tarjeta',
      },
      {
        name: 'cliente_clabe',
        label: 'CLABE Interbancaria',
        type: 'text',
        col: 12,
        required: true,
        validators: [Validators.required('La CLABE interbancaria es requerida')],
        placeholder: '18 dígitos numéricos',
        helperText: 'Clave Bancaria Estandarizada a 18 dígitos para transferencias SPEI',
      },
    ],
    [bancos]
  );

  const handleSubmit = useCallback(
    async (values) => {
      const payload = {
        id: clientId,
        ...values,
      };
      return await ClienteService.guardar(payload);
    },
    [clientId]
  );

  const handleSuccess = useCallback(
    (response) => {
      if (onSave) {
        onSave(response);
      }
    },
    [onSave]
  );

  return (
    <div className="space-y-6">
      <CatalogForm
        title="Datos de Pago y Cuentas Bancarias"
        subtitle="Registro de cuenta y CLABE para transferencias y reembolsos"
        fields={fields}
        id={clientId}
        loadData={loadClientData}
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        submitButtonText="Guardar Datos Bancarios"
      />
    </div>
  );
};

export default withRouter(ClientePagos);
